import React from 'react';
import { CircularProgress } from '@mui/material';
import { useAudit } from './useCPData';
import './ArtemyStyles.css';

const ACTION_COLORS = { policy_changed: 'var(--artemy-accent)', risk_resolved: 'var(--artemy-green)', risk_created: 'var(--artemy-yellow)', autonomy_update: 'var(--artemy-purple)', agent_action: 'var(--artemy-green)' };

function ActionPill({ action }) {
  const color = ACTION_COLORS[action] || 'var(--artemy-text-secondary)';
  return <span style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 10, color, background: `${color}1a`, padding: '2px 8px', borderRadius: 6, whiteSpace: 'nowrap', border: `1px solid ${color}33`, textTransform: 'uppercase' }}>{action.replace('_', ' ')}</span>;
}

export default function AuditLedger() {
  const { events, loading } = useAudit();

  return (
    <div className="artemy-fade-up">
      <div style={{ marginBottom: 22 }}>
        <div className="artemy-page-title">Audit Ledger</div>
        <div className="artemy-page-sub">Immutable log of all governance and agent actions</div>
      </div>

      <div className="artemy-card" style={{ overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--artemy-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontFamily: 'var(--artemy-font-display)', fontSize: 14, fontWeight: 600 }}>≡ Event Log</div>
          <div style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 11, color: 'var(--artemy-text-dim)' }}>{events.length} events verified</div>
        </div>
        {loading ? (
          <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}><CircularProgress size={28} sx={{ color: 'var(--artemy-accent)' }} /></div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>
                {['Timestamp', 'Action', 'Actor', 'Entity', 'Detail'].map((h) => (
                  <th key={h} style={{ textAlign: 'left', padding: '11px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {events.length === 0 ? (
                <tr><td colSpan={5} style={{ padding: 40, textAlign: 'center', color: 'var(--artemy-text-dim)' }}>No audit events yet</td></tr>
              ) : (
                events.map((ev, i) => (
                  <tr key={ev.event_id || i} style={{ borderBottom: '1px solid rgba(255,255,255,.03)', transition: 'background .15s' }}>
                    <td style={{ padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 11, color: 'var(--artemy-text-dim)', whiteSpace: 'nowrap' }}>{ev.timestamp || 'unknown'}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <ActionPill action={ev.action} />
                    </td>
                    <td style={{ padding: '12px 16px', color: 'var(--artemy-text-secondary)', fontWeight: 500 }}>{ev.actor}</td>
                    <td style={{ padding: '12px 16px', color: 'var(--artemy-text-secondary)' }}>{ev.entity}</td>
                    <td style={{ padding: '12px 16px', color: 'var(--artemy-text-dim)', fontSize: 12.5, lineHeight: 1.4 }}>{ev.detail}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
      <div style={{ height: 40 }} />
    </div>
  );
}
